import * as React from 'react';
// import { AppInsights } from 'applicationinsights-js';
import { ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../store/utils/i18n/strings.manager';
// import Error from './error.png';

const styles = {
    errorContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

interface PropsFromState {
    readonly currentLanguage: string;
}

interface IProps {
    children?: React.ReactNode;
}
interface IState {
    error: boolean;
    message: string;
}

type AllProps = PropsFromState & IProps;

class ErrorBoundary extends React.Component<AllProps, IState> {
    private localization: Ii18n;

    constructor(props: AllProps) {
        super(props);
        this.localization = getI18n();
        this.state = {
            error: false,
            message: ''
        };
    }

    componentDidCatch(err: Error, errInfo: React.ErrorInfo) {
        // console.log(err);
        // console.log(errInfo);
        // AppInsights.trackException(err, errInfo.componentStack.toString());
        this.setState({
            error: true,
            message: errInfo.componentStack ? errInfo.componentStack.toString() : ''
        });
    }

    render() {
        if (this.state.error) {
            return (
                <div style={styles.errorContainer}>
                    {/* <img
                        source={Error}
                        style={{ height: 150, width: 200 }}
                    /> */}
                    <span style={{ textAlign: 'center', fontSize: 16, padding: 10 }}>
                        {this.localization.get('unhandled.component.error.message')}
          </span>
                    {'production' !== process.env.REACT_APP_ENV ? (
                        <details style={{ textAlign: 'center', fontSize: 8, padding: 10 }}>
                            {this.state.message}
                        </details>
                    ) : null}
                </div>
            );
        }
        return this.props.children;
    }
}

const mapStateToProps = ({ shared: { currentLanguage } }: ApplicationState): PropsFromState => ({
    currentLanguage: currentLanguage
});

export default connect(mapStateToProps)(ErrorBoundary);
